import { api } from '../DefaultService';
import { IPaginationParams } from '../types';
import {
  ISchoolBoardCreateProps,
  ISchoolBoardFilterParams,
  ISchoolBoardProps,
  ISchoolBoardSimpleProps,
  ISchoolBoardUpdateParams,
} from './types';

const ENDPOINT = 'v1/schoolboard';

export const createSchoolBoardAsync = async (
  data: ISchoolBoardCreateProps,
): Promise<ISchoolBoardProps> => {
  return await api
    .post(`${ENDPOINT}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateSchoolBoardAsync = async ({
  id,
  data,
}: ISchoolBoardUpdateParams): Promise<ISchoolBoardProps> => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteSchoolBoardAsync = async (id: number) => {
  await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};

export const getSchoolBoardByIdAsync = async (
  id: number,
): Promise<ISchoolBoardProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

// ATUALIZADO: De /getAllByLicense para /list
export const getAllSchoolBoardsByLicenseAsync = async (
  pagination: IPaginationParams,
  filter: ISchoolBoardFilterParams,
): Promise<ISchoolBoardSimpleProps[]> => {
  return await api
    .get(`${ENDPOINT}/list`, {
      params: { ...pagination, ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

// ATUALIZADO: De /getAllByLicense/Count para /count
export const getAllSchoolBoardsByLicenseCountAsync = async (
  filter: ISchoolBoardFilterParams,
): Promise<number> => {
  return await api
    .get(`${ENDPOINT}/count`, { params: { ...filter } })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
